module.exports = __webpack_public_path__ + "img/zhuji.2206973c.svg";